import React from 'react';
import WealthGapCard from './WealthGapCard';

const ZoneBadge = ({ zone }) => {
  const color = zone === 'green' ? 'bg-green-100 text-green-700' : zone === 'yellow' ? 'bg-yellow-100 text-yellow-700' : 'bg-red-100 text-red-700';
  const label = zone ? zone.toUpperCase() : '';
  return <span className={`px-2 py-1 rounded ${color}`}>{label}</span>;
};

const ResultsStep = ({ user, onBack, track }) => {
  const goal = user?.readiness_goal_lump_sum || 0;
  const assets = user?.readiness_current_investable_assets || 0;
  const gap = user?.readiness_gap_value ?? (goal - assets);
  const pct = Math.round((user?.readiness_percent_to_goal || (goal > 0 ? assets / goal : 1)) * 100);
  const zone = user?.readiness_gap_zone;

  const recommend = () => {
    if (!zone || zone === 'green') return ['Legacy Planning', 'Tax Efficiency'];
    return ['Run Valuation', 'Continuity Roadmap', 'Succession Roadmap'];
  };

  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-semibold text-succession-text-primary">Your Readiness</h2>
      <WealthGapCard goal={goal} assets={assets} gap={gap} zone={zone} />
      <div>
        <h3 className="text-xl font-medium">Recommended Actions</h3>
        <ul className="list-disc ml-6">
          {recommend().map((r) => (
            <li key={r}>
              <button className="text-succession-primary hover:underline" onClick={() => track && track('readiness_cta_clicked', { destination: r })}>{r}</button>
            </li>
          ))}
        </ul>
      </div>
      <div>
        <button className="px-4 py-2 rounded border" onClick={onBack}>Back</button>
      </div>
    </div>
  );
};

export default ResultsStep;


